import { V2_COMPANY_ROUTE } from '@constants'

export const API_COMPANY_TAXATION_DETAILS_URL = `${V2_COMPANY_ROUTE}taxation/company-details`
